import { forwardRef } from 'react';
import { Heading as RacHeading, type HeadingProps as RacHeadingProps } from 'react-aria-components';
import { cn, tv } from 'tailwind-variants';
import type { HeadingLevel } from '#/_packages/umbrella/types';

const heading = tv({
    base: '',

    variants: {
        level: {
            1: 'h1',
            2: 'h2',
            3: 'h3',
            4: 'h4',
            5: 'h5',
            6: 'h6',
        },
    },
});

export interface HeadingProps extends Omit<RacHeadingProps, 'display'>, Omit<RacHeadingProps, 'level'> {
    display?: HeadingLevel;
    level: HeadingLevel;
}

export const Heading = forwardRef<HTMLHeadingElement, HeadingProps>(function Heading({ className, display, ...props }, ref) {
    return (
        <RacHeading
            {...props}
            ref={ref}
            className={cn(heading({ level: display }), className)}
        />
    );
});
